import gql from 'graphql-tag';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DataCafService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
        this.codigo_dte_seleccionada = new BehaviorSubject(0);
        this.codigo_dte_seleccionada$ = this.codigo_dte_seleccionada.asObservable();
    }
    getDataCaf(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: data_cafInputType) {
          data_caf {
            getDataCAF(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                codigo_dte
                nombre_dte
                fecha_emision
                fecha_vencimiento
                folios_disponibles
                ultimo_folio
                folios_inicial
                folios_final
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.data_caf.getDataCAF;
            callback({ mensajes, respuesta });
        });
    }
    getAllDataCaf(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: data_cafInputType) {
            data_caf {
              getAllDataCAF(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  codigo_dte
                  nombre_dte
                  fecha_emision
                  fecha_vencimiento
                  folios_disponibles
                  ultimo_folio
                  folios_inicial
                  folios_final
                }
              }
            }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.data_caf.getAllDataCAF;
            callback({ mensajes, respuesta });
        });
    }
    setDataCodigoDTE(codigo) {
        this.codigo_dte_seleccionada.next(codigo);
    }
}
DataCafService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataCafService_Factory() { return new DataCafService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DataCafService, providedIn: "root" });
